import PatchDataIcon from '@resources/icons/PatchData.svg?react';
import {
  OpenWidgetCommand,
  TeiaViewer,
  TeiaViewerSourceType,
  ToolbarItem,
  useTeiaSource,
  useViewerContext,
  useViewerSelection,
  useWidgetInfo,
} from '@stereograph/teiaviewer';
import { usePluginTranslation } from '@translation';

export const ShowTeiaPatchDataWidget = () => {
  const { t } = usePluginTranslation();
  const { viewer } = useViewerContext<TeiaViewer>();
  const twin = useTeiaSource(TeiaViewerSourceType.Twin);
  const { selection } = useViewerSelection();
  const { isOpened } = useWidgetInfo('TeiaPatchData');

  const onClick = () => {
    const command = new OpenWidgetCommand(viewer, 'TeiaPatchData');
    command.execute();
  };

  return (
    <ToolbarItem
      icon={PatchDataIcon}
      onClick={onClick}
      disabled={selection.length === 0 || !twin}
      label={t('toolbar.patch_data.tooltip')}
      data-dd-action-name="toolbar.patch_data"
      active={isOpened}
    />
  );
};
